<template>
    <b-overlay :show="toggleOverlay" rounded="sm">
        <b-container fluid class="mt--7 pb-4">
            <b-row>
                <b-col>
                    <b-overlay :show="showOverlay" rounded="sm">
                        <b-card v-if="isNew">
                            <b-card-header>
                                <b-button
                                    @click="$router.push('/admin/activities')"
                                    variant="light"
                                    class="float-right"
                                >
                                    <b-icon icon="x" />
                                </b-button>
                                <h3>New Activity</h3>
                            </b-card-header>
                            <b-card-body>
                                <b-alert :variant="formStatus.variant" :show="!!formStatus.message">{{ formStatus.message
                                }}</b-alert>
                                <portal-target name="OrderSummaryView">
                                </portal-target>
                            </b-card-body>
                        </b-card>

                        <b-card v-else>
                            <b-card-header>
                                <b-row class="align-items-center">
                                    <b-col class="col-6">
                                        <h3 class="mb-0">
                                            {{ orderType && orderType.name }}
                                            &nbsp;
                                            <small>
                                                <b-badge :variant="order
                                                    | filterStatusVariant
                                                    ">{{
        order | filterStatusName
    }}</b-badge><span>
                                                    {{
                                                        toStringDateTime(
                                                            order.completed_at
                                                        )
                                                    }}</span>
                                            </small>
                                        </h3>
                                    </b-col>
                                    <b-col class="text-right">
                                        <page-actions :buttons-actions="viewButtons" :dropdown-actions="otherActions"
                                            control-size="sm" :dropdown-disabled="isNew" />
                                    </b-col>
                                </b-row>
                            </b-card-header>

                            <b-tabs card v-model="tabIdx">
                                <b-tab title="Summary">
                                    <b-card-body>
                                        <portal-target name="OrderSummaryView">
                                        </portal-target>
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Location">
                                    <b-card-body>
                                        <portal-target name="deliveryLocationView"></portal-target>
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Details">
                                    <b-card-body>
                                        <portal-target name="OrderItemsView">
                                        </portal-target>
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Messages">
                                    <b-card-body>
                                        <portal-target name="OrderMessagesView">
                                        </portal-target>
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Attachments">
                                    <b-card-body>
                                        <portal-target name="OrderAttachmentsView">
                                        </portal-target>
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Reviews">
                                    <b-card-body>
                                        <view-checkoffs></view-checkoffs>
                                    </b-card-body>
                                </b-tab>

                                <b-tab title="Received By">
                                    <b-card-body>
                                        <view-received-by :order="order" />
                                    </b-card-body>
                                </b-tab>
                            </b-tabs>
                        </b-card>
                    </b-overlay>
                </b-col>
            </b-row>

            <create-template-from-order />

            <portal to="OrderSummaryView">
                <view-order-summary ref="ord-sum-ref" :view-mode="viewMode" :updating="updating"
                    @change-mode="viewMode = $event" />
            </portal>

            <portal to="deliveryLocationView">
                <location-section v-model="delivery_location_section_id" :hide-controls="!isNew"
                    :title="isNew ? '' : 'Delivery Location'" @update-section-model="evt => (deliveryLocation = evt)"
                    :disabled="!(isNew || !viewMode)">
                </location-section>
            </portal>

            <portal to="OrderItemsView">
                <manage-order-items :view-mode="viewMode" @change-mode="viewMode = $event"
                    :customer-assets="customerAssets" />
            </portal>

            <portal to="OrderMessagesView">
                <view-notes />
            </portal>

            <portal to="OrderAttachmentsView">
                <view-attachments />
            </portal>


            <b-modal
                id="convertOrderType"
                title="Convert to New Activity Type"
                v-model="isConvertOrderType"
                @ok="convertOrderType"
            >
                <b-form-group
                    id="input-group-type"
                    label="Type*:"
                    label-for="input-type"
                    label-class="font-weight-bold pt-0"
                    label-cols="2"
                >
                    <b-form-select
                        id="input-type"
                        v-model="new_order_type_id"
                        :options="orderTypes | mapOptions"
                        required
                    >
                        <template #first>
                            <b-form-select-option :value="null" disabled
                                >Select New Activity Type</b-form-select-option
                            >
                        </template>
                    </b-form-select>
                </b-form-group>
            </b-modal>

            <b-card>
                <b-button-group size="sm" class="float-right mt-2">
                    <b-button v-if="hasPermissionCreate && isNew" @click="createNewOrder" variant="primary"
                        :disabled="updating || !summaryChanged">{{ updating ? 'Creating' : 'Create' }}</b-button>

                    <b-button v-if="showLocationBtn" @click="setLocationSearchMode" variant="info"
                        :disabled="viewMode || updating">Change Location</b-button>

                    <b-button v-if="showUpdateBtn" variant="primary" @click="runSaveAction"
                        :disabled="updating || !saveActive">{{
                            updating ? 'Saving Changes...' : 'Save Changes'
                        }}</b-button>
                    <b-button variant="secondary" @click="cancel()">Cancel</b-button>
                </b-button-group>
            </b-card>
        </b-container>
    </b-overlay>
</template>
<script>
import EventBus from '@/exports/event-bus.js'
import api from '@/api/order'
import CreateTemplateFromOrder from '@/components/CreateTemplateFromOrder.vue'
import ManageOrderItems from './ManageOrderItems.vue'
import ViewNotes from './ViewNotes.vue'
import ViewAttachments from './ViewAttachments.vue'
import ViewReceivedBy from './ViewReceivedBy.vue'
import moment from 'moment'
import PageActions from '@/components/PageActions.vue'

import LocationSection from '@/views/Location/LocationSection'
import ViewOrderSummary from './ViewOrderSummary'
import ViewCheckoffs from './ViewCheckoffs.vue'
//mixins
import orderHelperMixins from '@/mixins/orderHelperMixins'
import popupMixins from '@/mixins/popupMixins'
import utilityMixins from '@/mixins/utilityMixins'
import permissionsMixins from '@/mixins/permissionsMixins'
//loader

const scheduledDate = new Date(Date.now() + 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0]
const scheduledTime = '09:30:00'

const tabNames = [
    'summary', // 0,
    'location', // 1,
    'items', // 2,
    'messages', // 3,
    'attachments', // 4,
    'reviews', // 5,
    'receivedBy', // 6,
]
export default {
    name: 'orders-view',
    components: {
        CreateTemplateFromOrder,
        ManageOrderItems,
        ViewNotes,
        LocationSection,
        ViewAttachments,
        ViewReceivedBy,

        ViewOrderSummary,
        ViewCheckoffs,
        PageActions,
    },
    mixins: [orderHelperMixins, popupMixins, utilityMixins, permissionsMixins],
    data() {
        return {
            tabIdx: 0,
            tabNames,

            viewMode: true,
            componentName: 'Order',
            delivery_location_section_id: null,
            order_type_id: null,
            new_order_type_id: null,
            formStatus: {},
            driverModified: false,
            updating: false,
            toggleOverlay: false,
            summaryChanged: false,
            deliveryLocation: {},
            previousModel: null,
            customerAssets: [],
            isConvertOrderType: false,
        }
    },
    filters: {
        capitalize: function (value) {
            if (!value) return ''
            value = value.toString()
            return value.charAt(0).toUpperCase() + value.slice(1)
        },
        filterStatusName(item) {
            return item.completed
                ? 'Completed'
                : item.released
                    ? 'Processing'
                    : 'Pending'
        },

        filterStatusVariant(item) {
            return item.completed
                ? 'success'
                : item.released
                    ? 'primary'
                    : 'danger'
        },
        mapOptions(arr, isUser) {
            return arr.map(x => ({
                value: x.id,
                text: isUser ? `${x.first_name} ${x.last_name}` : x.name,
            }))
        },
    },

    computed: {
        viewButtons() {
            const actions = []
            if (!this.isNew) {
                actions.push({
                    action: () => this.toggleView(),
                    icon: this.viewMode ? 'pencil' : 'eye',
                    variant: 'light',
                    tooltip: this.viewMode
                        ? 'Switch to Edit State'
                        : 'Switch to View State',
                })
            }
            actions.push({
                action: () => this.launchNewOrder(),
                icon: 'plus-circle',
                variant: 'light',
                size: 'sm',
                tooltip: 'Create New Activity',
            })
            return actions
        },
        otherActions() {
            const actions = []

            actions.push({
                action: () => this.cancelOrder(),
                text: 'Cancel Activity',
            })
            actions.push({
                action: () => this.toggleCompletion(),
                text: this.order.completed
                    ? 'Mark as Incomplete'
                    : 'Mark as Complete',
            })

            if (this.hasPermissionCreate) {
                actions.push({
                    action: () => this.openConvertOTModal(),
                    text: 'Convert Activity',
                })
            }
            if (
                this.hasPermissionUpdate &&
                this.orderItems.length > 0 &&
                this.orderItems.some(x => x.id)
            ) {
                actions.push({
                    action: () => this.showOrderTemplateModal(),
                    text: 'Create  Template',
                })
                actions.push({
                    action: () => this.downloadPdf('invoice-statement'),
                    text: 'Download Invoice',
                })
                if (this.isCustomStatement) {
                    actions.push({
                        action: () => this.downloadPdf('fulfilment-note-two'),
                        text: 'Download Statement',
                    })
                } else {
                    actions.push({
                        action: () => this.downloadPdf('fulfilment-note-one'),
                        text: 'Download Statement',
                    })
                }
            }
            if (this.hasPermissionDelete) {
                actions.push({
                    action: () => this.deleteOrder(),
                    text: 'Delete Activity',
                })
            }
            return actions
        },

        isCustomStatement() {
            return !!(this.taskTypeValue && this.taskTypeValue.isTaskType)
        },

        entities() {
            const _entities = this.$store.getters['transactionType/entities']
            console.log('----entities', _entities)
            return _entities
        },
        entity() {
            ///// this.orderTypes.find(x => x.id === this.order.order_type_id) ||
            const { orderTypes, order_type_id, orderType } = this
            console.log('order type----', {
                orderTypes,
                orderType,
                order_type_id,
            })
            return (
                orderType &&
                orderType.transaction_type &&
                orderType.transaction_type.entity
            )
        },
        orderTypes() {
            const orderTypes = this.$store.state.orderType.items
            console.log('orderTypes', orderTypes)
            return orderTypes
        },
        showOverlay() {
            return this.$store.state.orders.orderLoadingState
        },

        order() {
            return this.$store.state.orders.item
        },

        orderItems() {
            return this.$store.state.orders.orderItems
        },

        warehouses() {
            return this.$store.state.orders.warehouses
        },

        orderId() {
            return this.$route.params.id
        },

        isNew() {
            return !(this.$route.params.id > 0)
        },

        orderType() {
            const { orderTypes, order_type_id } = this
            return orderTypes.find(x => x.id === order_type_id)
        },

        storedItems() {
            return this.$store.state.orderItemStore.items
        },

        storedMessages() {
            return this.$store.state.orderMessagesStore.messages
        },

        storedAttachments() {
            return this.$store.state.orderAttachmentsStore.attachments
        },

        attachmentsChanged() {
            return this.$store.state.orderAttachmentsStore.itemsChanged
        },

        itemsChanged() {
            return this.$store.state.orderItemStore.itemsChanged
        },

        messagesChanged() {
            return this.$store.state.orderMessagesStore.itemsChanged
        },

        showUpdateBtn() {
            return this.hasPermissionUpdate && !this.isNew && this.tabIdx <= 4
        },

        showLocationBtn() {
            const { tabNames, tabIdx, hasPermissionUpdate } = this
            return hasPermissionUpdate && tabNames[tabIdx] == 'location'
        },
        saveActive() {
            const {
                summaryChanged,
                itemsChanged,
                messagesChanged,
                attachmentsChanged,
                tabIdx,
                tabNames,
                viewMode,
            } = this
            return (
                (tabNames[tabIdx] == 'summary' &&
                    summaryChanged &&
                    !viewMode) ||
                (tabNames[tabIdx] == 'location' && !viewMode) ||
                (tabNames[tabIdx] == 'items' && itemsChanged) ||
                (tabNames[tabIdx] == 'messages' && messagesChanged) ||
                (tabNames[tabIdx] == 'attachments' && attachmentsChanged) ||
                tabIdx > 4
            )
        },

        /////////////////////////////task type settings
        taskTypeValue() {
            const taskTypeValue = this.$store.getters['company/taskTypeValue']
            console.log('computed taskTypeValue', taskTypeValue)
            return taskTypeValue
        },

        taskTypeKey() {
            return this.$store.state.company.settingKeys.taskTypeKey
        },
    },

    watch: {
        order: {
            handler: function () {
                this.previousModel = null
            },
            deep: true,
        },
        $route() {
            const id = parseInt(this.$route.params.id)
            console.log('$route watch id', id)
            this.fetchOrder(id)
        },

        tabIdx: function (idx) {
            console.log('tabIdx', idx)
            if (idx === 2) {
                console.log('')
            }
        },
    },
    created() {
        this.$store.dispatch('orderType/fetchAll')
        this.$store.dispatch('requestCategory/fetchAll')
        this.$store.dispatch('checkoffTypes/fetchAll')
        this.$store.dispatch('users/fetchAll')

        const id = parseInt(this.$route.params.id)
        console.log('route.params.id', id)
        if (id) {
            this.$store.dispatch('locations/fetchWarehouses')
            this.$store.dispatch('itemType/fetchAll')
        }
        this.fetchOrder(id)

        EventBus.$on('set-order-model', ({ order, driverModified }) => {
            console.log('orderModel--viewOrder', order)
            console.log('modified officer', driverModified)
            this.driverModified = driverModified
            this.order_type_id = order && order.order_type_id
            this.$nextTick(() => {
                this.checkOrderModel(order)
                this.setDeliveryLocation(order)
                this.getCustomerAllAssets(order.customer_id)
            })
        })
    },

    mounted() {
        this.$store.dispatch('company/fetchConfiguration', this.taskTypeKey)
    },

    methods: {
        cancel() {
            this.$router.push('/admin/orders')
        },
        setLocationSearchMode() {
            EventBus.$emit('set-location-search-mode')
        },
        setDeliveryLocation(orderModel) {
            let { isNew, delivery_location_section_id, previousModel, order } =
                this
            if (
                isNew &&
                (!previousModel ||
                    previousModel.customer_id !== orderModel.customer_id)
            ) {
                this.delivery_location_section_id =
                    delivery_location_section_id ||
                    (orderModel &&
                        orderModel.customer &&
                        orderModel.customer.location_section_id) ||
                    null
            } else if (!isNew && !previousModel) {
                this.delivery_location_section_id =
                    order && order.delivery_location_section_id
            }
            this.previousModel = { ...orderModel }
        },
        cancelOrder() {
            this.$router.push('/admin/orders')
        },
        checkOrderModel(model) {
            const {
                order_type_id,
                entity,
                entities: { Customer, Internal },
            } = this
            console.log({ entity, Internal })
            console.log('model', model)
            const notValidCustomerState =
                entity == Customer &&
                !model.customer_id &&
                (!model.customer || !model.customer.name)
            console.log('customerState', notValidCustomerState)
            const notValidDriverState = entity != Internal && !model.driver_id
            this.summaryChanged = notValidCustomerState
                ? false
                : !order_type_id
                    ? false
                    : notValidDriverState
                        ? false
                        : true

            if (notValidCustomerState) {
                this.$set(this.formStatus, 'message', 'Customer is Required')
                this.$set(this.formStatus, 'variant', 'warning')
            } else if (notValidDriverState) {
                this.$set(this.formStatus, 'message', 'Officer is Required')
                this.$set(this.formStatus, 'variant', 'warning')
            } else if (this.summaryChanged) {
                this.$set(this.formStatus, 'message', '')
                this.$set(this.formStatus, 'variant', 'success')
            }
        },
        toggleView() {
            this.viewMode = !this.viewMode
        },
        launchNewOrder() {
            this.$router.push('/admin/activities/0')
        },
        showOrderTemplateModal() {
            this.$refs['ord-sum-ref'].showOrderTemplateModal()
        },
        async downloadPdf(statement_type) {
            try {
                this.toggleOverlay = true
                const { orderId: order_id } = this
                const fileName = 'statement.pdf'
                await this.$store.dispatch('js_report/downloadStatement', {
                    order_id,
                    statement_type,
                    fileName,
                })
            } catch (error) {
                console.error('downloadPdf:', error)
                this.doToast('Error!', 'Error Downloading Report!', 'danger')
            } finally {
                this.toggleOverlay = false
            }
        },

        fetchOrder(id) {
            if (id) {
                this.$store.dispatch('orders/fetchById', id)
                this.$store.dispatch('orders/fetchOrderItems', id)
            } else {
                this.$store.commit('orders/SET_ORDER', {})
                this.$store.commit('orders/SET_ORDER_ITEMS', [])
            }
        },

        buildDuplicateOrder(order_type_id) {
            const {
                customer_id,
                driver_id,
                order_type_id: p_order_type_id,
                description,
                delivery_location_section_id,
                request_category_id,
                signature,
                items,
            } = this.order
            if (!customer_id)
                throw new Error('Invalid Activity! Customer not assigned!')
            if (!items || items.length == 0)
                throw new Error('Invalid Activity! Items not assigned!')

            order_type_id = order_type_id || p_order_type_id

            const model = {
                customer_id,
                driver_id,
                description,
                order_type_id,
                delivery_location_section_id,
                request_category_id,
                signature,
            }

            model.duplicate_order_id = this.order.id
            model.schedule_at = this.getScheduleAt(scheduledDate, scheduledTime)
            return model
        },

        async openConvertOTModal() {
            this.isConvertOrderType = true
        },

        async convertOrderType() {
            try {
                this.toggleOverlay = true

                const { new_order_type_id } = this

                const model = this.buildDuplicateOrder(new_order_type_id)

                const data = await this.$store.dispatch('orders/create', model)

                console.log('created data', data)
                this.doToast(
                    'Success',
                    `Order ${data.reference_no} Created!`,
                    'success'
                )

                this.isConvertOrderType = false
                this.$router.push(`/admin/activities/${data.id}`)
            } catch (err) {
                console.log(err)
                this.doToast('Invalid', err.message, 'danger')
            } finally {
                this.toggleOverlay = false
            }
        },

        runSaveAction() {
            const { tabNames, tabIdx } = this
            if (tabNames[tabIdx] == 'summary') {
                this.updateOrder()
            }
            if (tabNames[tabIdx] == 'location') {
                this.updateOrder()
            }
            if (tabNames[tabIdx] == 'items') {
                this.updateOrderItems()
            }
            if (tabNames[tabIdx] == 'messages') {
                this.updateNotes()
            }

            if (tabNames[tabIdx] == 'attachments') {
                this.updateAttachments()
            }
            /*
            if (tabNames[tabIdx] == 'reviews') {
            } // 5,
            if (tabNames[tabIdx] == 'receivedBy') {
            } // 6, */
        },

        async updateAttachments() {
            const saveAttachment = async payload => {
                payload.order_id = this.order.id
                await this.$store.dispatch('orders/addAttachment', payload)
            }

            const deleteAttachment = async id => {
                await this.$store.dispatch('orders/deleteAttachment', {
                    order_id: this.order.id,
                    attachment_id: id,
                })
            }

            try {
                this.updating = true
                const { storedAttachments: newAttachments } = this
                const markedDeletedArray = []
                for (const oldAttachment of this.order.attachments) {
                    if (
                        !newAttachments
                            .filter(x => !!x.id)
                            .find(x => x.id == oldAttachment.id)
                    ) {
                        markedDeletedArray.push(oldAttachment.id)
                    }
                }
                //delete messages
                await Promise.all(markedDeletedArray.map(deleteAttachment))
                //create messages
                await Promise.all(
                    newAttachments.filter(x => !x.id).map(saveAttachment)
                )
                await this.$store.dispatch('orders/fetchById', this.order.id)
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        async updateNotes() {
            const createNote = async content => {
                await api.createNote(this.order.id, content)
            }

            const deleteNote = async id => {
                await api.deleteNote(this.order.id, id)
            }
            try {
                this.updating = true
                const { storedMessages: newNotes } = this
                const markedDeletedArray = []
                for (const oldNote of this.order.notes) {
                    if (
                        !newNotes
                            .filter(x => !!x.id)
                            .find(x => x.id == oldNote.id)
                    ) {
                        markedDeletedArray.push(oldNote.id)
                    }
                }
                //delete messages
                await Promise.all(markedDeletedArray.map(deleteNote))
                //create messages
                await Promise.all(
                    newNotes.filter(x => !x.id).map(x => createNote(x.content))
                )
                await this.$store.dispatch('orders/fetchById', this.order.id)
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        async updateOrderItems() {
            try {
                this.updating = true
                const model = this.$refs['ord-sum-ref'].getModel()
                const { id } = model
                const total = 0
                const { storedItems: items } = this
                console.log('updateOrderItems items', items)
                await this.$store.dispatch('orders/updateOrderItems', {
                    id,
                    items,
                    total,
                })
            } catch (error) {
                this.doToast('Error!', error.message, 'danger')
            } finally {
                this.updating = false
            }
        },

        async createNewOrder() {
            try {
                this.updating = true

                const summary = this.$refs['ord-sum-ref'].getModel()
                const {
                    storedItems: items,
                    storedMessages: _notes,
                    storedAttachments: attachments,
                    delivery_location_section_id,
                    deliveryLocation,
                } = this

                console.log(
                    'delivery location section id',
                    delivery_location_section_id
                )

                const notes = _notes.map(x => x.content)

                console.log('deliveryLocation', deliveryLocation)

                const model = {
                    ...summary,
                    ...deliveryLocation,
                    items,
                    notes,
                    attachments,
                    delivery_location_section_id,
                }

                model.schedule_at = this.getScheduleAt(model.date, model.time)
                model.signature = model.signature || false
                delete model.date
                delete model.time

                console.log('model', model)

                await this.$refs['ord-sum-ref'].validateOrderSummary()

                const data = await this.$store.dispatch('orders/create', model)

                console.log('created data', data)
                this.doToast(
                    'Success',
                    `Order ${data.reference_no} Created!`,
                    'success'
                )
                this.$router.push(`/admin/activities/${data.id}`)
            } catch (err) {
                console.error('createNewOrder', err)
                //"SQLSTATE[23000]: Integrity constraint violation: 1062 Duplicate entry 'Del-110' for key 'orders_reference_no_unique' (SQL: insert into `orders` (`request_category_id`, `customer_id`, `driver_id`, `description`, `delivery_location_section_id`, `created_by`, `schedule_at`, `signature`, `order_type_id`, `reference_no`, `order_template_id`, `linked_assets`, `updated_at`, `created_at`) values (3, 1, 18, testr, 5, 1, 2022-11-11 09:30:00, 0, 1, Del-110, , [], 2022-11-10 20:58:00, 2022-11-10 20:58:00))"
                const duplicateCustomerName = 'Duplicate Name'
                const invalidCustomerNameMsg =
                    "Cannot read properties of undefined (reading 'name')"
                let message = err.message

                if (message == duplicateCustomerName) {
                    message = 'Customer Name Already Exists!'
                }
                if (message == invalidCustomerNameMsg) {
                    message = 'Customer Name is Required!'
                }

                if (
                    message.indexOf('Duplicate entry') >= 0 &&
                    message.indexOf('orders_reference_no_unique') >= 0
                ) {
                    message = 'Duplicate Reference Number!'
                }

                this.doToast('Invalid', message, 'danger')
            } finally {
                this.updating = false
            }
        },

        async updateOrder() {
            try {
                const { delivery_location_section_id, deliveryLocation } = this
                const summary = { ...this.$refs['ord-sum-ref'].getModel() }

                const { date, time, signature } = summary

                delete summary.date
                delete summary.time

                const schedule_at = this.getScheduleAt(date, time)

                summary.signature = signature ? 1 : 0

                const updateModel = {
                    ...summary,
                    ...deliveryLocation,
                    delivery_location_section_id,
                    schedule_at,
                }

                console.log('updateModel:', updateModel)
                this.updating = true

                await this.$store.dispatch('orders/update', updateModel)
                let toastComponentName = 'Order'

                if (this.driverModified == true) {
                    toastComponentName = 'Officer'
                }
                this.genericToast(
                    this.componentName,
                    'Updated',
                    'success',
                    `${toastComponentName} successfully updated`
                )
                this.driverModified = false
                this.viewMode = true
                this.$forceUpdate()
            } catch (error) {
                console.error('update', error)
                this.doToast('Error!', 'Error Updating Activity!', 'danger')
            } finally {
                console.log('done bingo bye')
                this.updating = false
            }
        },

        currency(num) {
            num = parseFloat(num)
            console.log('num.......', num)
            try {
                return num.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
            } catch (err) {
                return '0.00'
            }
        },
        toggleCompletion() {
            if (this.order.completed) {
                this.markAsIncomplete()
            } else {
                this.markAsComplete()
            }
        },
        async markAsComplete() {
            const title = 'Mark as Complete?'
            const message = `Are you sure you want to mark this activity as complete?`
            const result = await this.confirmMessage(title, message)
            if (!result) return
            navigator.geolocation.getCurrentPosition(async p => {
                try {
                    this.updating = true
                    const id = this.$route.params.id;
                    const address = {
                        lat: p.coords.latitude,
                        long:  p.coords.longitude,
                    }
                    await this.$store.dispatch('orders/markAsComplete', { id, address });
                    this.genericToast(
                        this.componentName,
                        'Updated',
                        'success',
                        'Order successfully marked as complete'
                    )
                } catch (error) {
                    console.error('mark as complete', error)
                    this.doToast(
                        'Error Marking as Complete!',
                        'Unable to Mark as Completed!',
                        'danger'
                    )
                } finally {
                    this.updating = false
                }
            })
        },
        async markAsIncomplete() {
            const title = 'Mark as Incomplete?'
            const message = `Are you sure you want to mark this activity as incomplete?`
            const result = await this.confirmMessage(title, message)
            if (!result) return

            try {
                this.updating = true
                await this.$store.dispatch(
                    'orders/markAsIncomplete',
                    this.$route.params.id
                )

                this.genericToast(
                    this.componentName,
                    'Updated',
                    'success',
                    'Activity successfully marked as incomplete'
                )
            } catch (error) {
                console.error('markAsIncomplete', error)
                this.doToast(
                    'Error Marking as Incomplete!',
                    'Error Marking as Incomplete!',
                    'danger'
                )
            } finally {
                this.updating = false
            }
        },

        deleteOrder() {
            // Initializing key variables
            const { id } = this.order
            const name = 'Order'
            const model = { id, name }

            const routes = {
                baseRoute: '/orders',
                deleteRoute: 'orders/delete',
            }
            const notificationFields = {
                type: 'Order',
                errorMsg: 'Unable to delete activity',
            }

            this.deleteItem(notificationFields, model, routes)
        },

        async getCustomerAllAssets(customer_id) {
            const $this = this
            this.customerAssets.splice(0)
            if (!customer_id) return

            console.log('getCustomerAllAssets customer_id', customer_id)

            const asyncNextTick = () => {
                return new Promise(resolve => {
                    $this.$nextTick(() => resolve())
                })
            }

            const query = ''
            const filters = { customer_id }

            let assets = []
            let page = 1
            do {
                await this.$store.dispatch('assets/fetch', {
                    query,
                    page,
                    filters,
                })

                await asyncNextTick()

                const { assets } = this.$store.state.assets
                page++

                for (const asset of assets) {
                    const { id, name, serial_no } = asset
                    if (!this.customerAssets.some(x => x.id == id))
                        this.customerAssets.push({ id, name, serial_no })
                }
                // code block to be executed
            } while (assets.length > 0)
            console.log('getCustomerAllAssets ', this.customerAssets)
        },
        toStringDateTime(value) {
            return value ? moment(value).format('LLLL') : ''
        },
    },
}
</script>
